module.exports = __webpack_public_path__ + "07a6deb8332d98032bbef7a048d84705.jpg";